module.exports = __webpack_public_path__ + "static/assets/liveness_detected.png";